import React from "react";
import { Formik, Form } from "formik";
import { MdSupervisedUserCircle, MdAccountCircle } from "react-icons/md";
import { MdClose, MdCheck } from "react-icons/md";
import { FaUsersCog } from "react-icons/fa";

import SelectAssignee from "../forms/SelectAssignee";
import { Settings } from "../../helpers/Contexts";

const TaskAgents = ({ data, formHandler, assigner }) => {
  const settings = React.useContext(Settings);
  const [reAssignTask, setReassignTask] = React.useState(false);
  let allowSelectAssignee = data.task && data.task.task_type != "specialist_referral";

  return (
    <>
      <label>Assigner </label>
      {assigner.name == "No Assigner" && (
        <>
          <FaUsersCog className="task-agent" />
          <b>{"System"}</b>
        </>
      )}
      {assigner.id && (
        <>
          <MdAccountCircle
            className="task-agent"
            id={assigner.inSession ? "logged-in" : undefined}
          />
          <b>{assigner.name} </b>
          <small>
            {(data.assigner_support_group && data.assigner_support_group) ||
              (assigner.pcp_group && assigner.pcp_group)}
          </small>
        </>
      )}

      {!reAssignTask && (
        <div>
          <label>
            Assignee{" "}
            { allowSelectAssignee && (
              <a onClick={() => setReassignTask(true)}>
                <i className="ml5 fa fa-edit blue-text" />
              </a>
            )}
          </label>

          {data.assignee.name == "No Assignee" ? (
            <>
              {data.assignee_support_group ? (
                <>
                  <MdSupervisedUserCircle className="task-agent" />
                  <b>{data.assignee_support_group} </b>
                </>
              ) : (
                <b> {"Not assigned! "}</b>
              )}
            </>
          ) : (
            <>
              <MdAccountCircle
                className="task-agent"
                id={data.inSession ? "logged-in" : undefined}
              />
              <b>{data.assignee.name} </b>
              <small>
                {(data.assignee_support_group && data.assignee_support_group) ||
                  (data.assignee.pcp_group && data.assignee.pcp_group)}{" "}
              </small>
            </>
          )}
        </div>
      )}
      {reAssignTask && (
        <Formik
          initialValues={{
            assignee_id: data.assignee.id,

            assignee:
              data.assignee.name !== "No Assignee"
                ? data.assignee.name
                : data.assignee_support_group
                ? data.assignee_support_group
                : "",
            assignee_support_group_id: data.assignee_support_group_id,
            assigner_support_group_id: settings.me.support_group_id,
          }}
          onSubmit={(values) => {
            formHandler({
              task: {
                id: data.id,
                assignee_id: values.assignee_id,
                assigner_id: settings.me.id,
                assigner_support_group_id: settings.me.support_group_id,
                assignee_support_group_id: values.assignee_support_group_id,
              },
            });
          }}
        >
          {({ values, setFieldValue, touched }) => {
            return (
              <Form>
                { allowSelectAssignee && <SelectAssignee
                  name="assignee"
                  agent={data.assignee.name !== "No Assignee" ? true : false}
                  setFieldValue={setFieldValue}
                /> }

                {values.assignee && (
                  <div className="check-cancel-buttons">
                    <button className="check small" type="submit">
                      <MdCheck className="check-icon" />
                    </button>
                    <button
                      className="cancel small"
                      onClick={() => reAssignTask && setReassignTask(false)}
                    >
                      <MdClose className="cancel-icon" />
                    </button>
                  </div>
                )}
              </Form>
            );
          }}
        </Formik>
      )}
    </>
  );
};

export default TaskAgents;
